import DOMPurify from "dompurify";

/**
 * TenantParameter (CKEditor) ile kaydedilen B2B açıklama HTML'ini temizler.
 * Stored XSS / phishing link enjeksiyonunu azaltır; sunucu tarafı doğrulama ayrıca önerilir.
 */
const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "strike",
    "sub",
    "sup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "ul",
    "ol",
    "li",
    "blockquote",
    "a",
    "span",
    "div",
    "img",
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    "caption",
    "colgroup",
    "col",
    "hr",
    "font",
  ],
  ALLOWED_ATTR: [
    "href",
    "target",
    "rel",
    "title",
    "class",
    "id",
    "style",
    "src",
    "alt",
    "width",
    "height",
    "colspan",
    "rowspan",
    "align",
    "valign",
    "color",
    "size",
    "face",
  ],
  ADD_ATTR: ["target"],
  ALLOW_UNKNOWN_PROTOCOLS: false,
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
};

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("rel", "noopener noreferrer");
    node.setAttribute("target", "_blank");
  }
});

/**
 * @param {string | null | undefined} html
 * @returns {string}
 */
export function sanitizeTenantRichText(html) {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html), RICH_TEXT_CONFIG);
}
